import React from "react";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import BeachAccessRoundedIcon from "@mui/icons-material/BeachAccessRounded";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { useLocation, useNavigate } from "react-router-dom";

// Core one-tap destinations for phone users. "More" opens the full nav drawer.
// Every role has these four, so no role-gating is needed here.
const ITEMS = [
  { label: "Home", icon: <HomeRoundedIcon />, path: "/EmployeeDashboard" },
  { label: "Attendance", icon: <AccessTimeRoundedIcon />, path: "/AttendancePortal" },
  { label: "Leave", icon: <BeachAccessRoundedIcon />, path: "/ApplyForLeave" },
  { label: "Payslips", icon: <PaymentsRoundedIcon />, path: "/payroll/my-payslips" },
];

/**
 * Fixed bottom navigation shown only on phones (rendered by AppShell behind an
 * isMobile guard, so it never exists in the DOM at desktop widths / under E2E).
 * Gives the app a native feel and one-tap access to the most common screens,
 * filling the bottom space AppShell already reserves via pb.
 */
export default function MobileBottomNav({ onMore }) {
  const location = useLocation();
  const navigate = useNavigate();

  // Highlight the tab whose path prefixes the current route; else none.
  const activeIndex = ITEMS.findIndex(
    (it) => location.pathname === it.path || location.pathname.startsWith(it.path + "/")
  );

  return (
    <Paper
      elevation={0}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (t) => t.zIndex.appBar,
        borderTop: "1px solid",
        borderColor: "divider",
        borderRadius: 0,
        // Respect the iOS home-indicator safe area.
        pb: "env(safe-area-inset-bottom)",
        display: { xs: "block", md: "none" },
      }}
    >
      <BottomNavigation
        showLabels
        value={activeIndex}
        sx={{
          height: 60,
          bgcolor: "background.default",
          "& .MuiBottomNavigationAction-root": { minWidth: 0, py: 0.5 },
          "& .MuiBottomNavigationAction-label": { fontSize: "0.68rem", fontWeight: 600, mt: 0.25 },
          "& .Mui-selected .MuiBottomNavigationAction-label": { fontSize: "0.7rem" },
        }}
      >
        {ITEMS.map((it) => (
          <BottomNavigationAction
            key={it.path}
            label={it.label}
            icon={it.icon}
            onClick={() => navigate(it.path)}
          />
        ))}
        <BottomNavigationAction label="More" icon={<MenuRoundedIcon />} onClick={onMore} />
      </BottomNavigation>
    </Paper>
  );
}
